import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading || user === null) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50">
        <Loader2 className="h-6 w-6 animate-spin text-slate-500" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="flex h-screen items-center justify-center bg-slate-50 px-4 text-center">
        <div data-testid="forbidden-message">
          <p className="text-sm uppercase tracking-wider text-slate-500">403</p>
          <p className="mt-2 text-lg font-semibold text-slate-900">Akses ditolak</p>
          <p className="mt-1 text-sm text-slate-600">Role Anda ({user.role}) tidak diizinkan membuka halaman ini.</p>
        </div>
      </div>
    );
  }
  return children;
}
